import React, { useCallback } from 'react'
import { Loader } from '../Loader'

type Props = {
  next: () => void
}

export const InfiniteLoad = ({ next }: Props) => {
  const ref = useCallback(
    (node: HTMLDivElement | null) => {
      if (!node) return

      const observer = new IntersectionObserver((payload) => {
        if (payload[0].isIntersecting) {
          next()
        }
      })

      observer.observe(node)
    },
    [next],
  )

  return (
    <div ref={ref}>
      <Loader />
    </div>
  )
}
